import API from 'utils/api';
import getFormattedValues, { hasFiles } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = '/relojchecador/documentos-justificacion-reloj-checador-grupal';
const headers = { 'Content-Type': 'multipart/form-data' };
const files = ['archivo'];

/**
 * GET Documento Justificación Grupal
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getDocumentosJustificacionGrupal = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * GET Documentos Justificación Grupal
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getDocumentosJustificacionesGrupal = async (params) => {
  try {
    const response = await API.get(`${baseURI}`, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * POST Documento Justificación Grupal
 * @param {FormData} formData
 * @returns {Promise<object|boolean>}
 */
export const postDocumentosJustificacionGrupal = (formData) => API.post(`${baseURI}/`, formData, {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});

/**
 * PATCH Documento Justificación Grupal
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchDocumentosJustificacionGrupal = async (id, values) => {
  try {
    const config = hasFiles(values, files) ? { headers } : {};
    getFormattedValues(values, {
      files,
      formData: config.headers,
      clean: true,
    });
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Documento Justificación Grupal
 * @param {number} id
 * @return {Promise<boolean>}
 */
export const deleteDocumentosJustificacionGrupal = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
